import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

import "./FAQ.css";

interface FAQCardProps {
  question: string;
  answer: React.ReactNode;
}

export const FAQCard: React.FC<FAQCardProps> = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="card" onClick={() => setIsOpen(!isOpen)}>
      <div className="cardHeader">
        <p className="question">{question}</p>
        <span className="icon">{isOpen ? "-" : "+"}</span>
      </div>
      <AnimatePresence initial={false}>
      {isOpen && <motion.div
            key="content"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.1, ease: "easeInOut" }}
            className="answer"
          >
            <p>{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>
  );
};
